import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, map, take } from 'rxjs';
import { ConfigService } from '../config/config.service';

const PLATFORM_ADMIN_ROLE = 'Global-Admin';

export function isPlatformAdmin(msalService: MsalService, spiritTenantId: string): boolean {
  const account = msalService.instance.getActiveAccount() ?? msalService.instance.getAllAccounts()[0] ?? null;
  if (!account) return false;
  const claims = account.idTokenClaims as { tid?: string; roles?: string[] } | undefined;
  return claims?.tid === spiritTenantId && (claims?.roles ?? []).includes(PLATFORM_ADMIN_ROLE);
}

export const platformAdminGuard: CanActivateFn = () => {
  const msalService = inject(MsalService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const configService = inject(ConfigService);
  const router = inject(Router);

  return msalBroadcastService.inProgress$.pipe(
    filter((status) => status === InteractionStatus.None),
    take(1),
    map(() => isPlatformAdmin(msalService, configService.azure.tenantId) || router.createUrlTree(['/'])),
  );
};
